import {
	GET_ATF_PROFILE,
	GET_ATF_PROFILE_SUCCESS,
	GET_ATF_PROFILE_FAIL,
	EDIT_ATF_PROFILE_SUCCESS,
	EDIT_ATF_PROFILE_FAIL,
	EDIT_ATF_PROFILE,
	ATF_EDIT_RESET,
} from '../../constants/globalProfileConstants/atfProfileConstants';

/**
 * Reducer function for managing ATF Profile list state.
 *
 * This reducer handles actions related to fetching ATF Profile data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the ATF Profile list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const atfProfileListReducer = (
	state = { atfProfileList: {} },
	action
) => {
	switch (action.type) {
		case GET_ATF_PROFILE:
			return {
				loading: true,
			};
		case GET_ATF_PROFILE_SUCCESS:
			return {
				loading: false,
				atfProfileList: action.payload,
			};
		case GET_ATF_PROFILE_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const atfProfileEditReducer = (
	state = { errorEdit: null, successMessage: '' },
	action
) => {
	switch (action.type) {
		case EDIT_ATF_PROFILE:
			return {
				...state,
				loadingEdit: true,
			};
		case EDIT_ATF_PROFILE_SUCCESS:
			return {
				...state,
				loadingEdit: false,
				successMessage: action.successMessage,
			};
		case EDIT_ATF_PROFILE_FAIL:
			return {
				...state,
				loadingEdit: false,
				errorEdit: action.payload,
			};
		case ATF_EDIT_RESET:
			return {
				...state,
				loadingEdit: false,
				successMessage: null,
				errorEdit: null,
			};

		default:
			return state;
	}
};
